import { Effects } from "@react-three/drei";
import { extend, useThree } from "@react-three/fiber";
import { useMemo, useRef, useState } from "react";
import { useOutline } from "../../../common/hooks";

import { LinearFilter, RGBAFormat, WebGLRenderTarget, Vector2 } from "three";

import { OutlinePass } from "three/examples/jsm/postprocessing/OutlinePass";
import { RenderPass } from "three/examples/jsm/postprocessing/RenderPass";
import { SMAAPass } from "three/examples/jsm/postprocessing/SMAAPass";
// import { CelShadingPass } from "./CelShadingPass";
// import { FXAAShader } from "three/examples/jsm/shaders/FXAAShader";

extend({ RenderPass, OutlinePass, SMAAPass });

export const Postprocessing = (props) => {
  const { gl, scene, camera, size } = useThree();
  const [target] = useState(
    () =>
      new WebGLRenderTarget(size.width, size.height, {
        minFilter: LinearFilter,
        magFilter: LinearFilter,
        format: RGBAFormat,
        stencilBuffer: false,
      })
  );
  const composer = useRef();
  const { hovered } = useOutline();
  const aspect = useMemo(() => new Vector2(size.width, size.height), [size]);

  return (
    <Effects ref={composer} args={[gl, target]}>
      <renderPass attachArray="passes" args={[scene, camera]} />
      <outlinePass
        attachArray="passes"
        args={[aspect, scene, camera]}
        selectedObjects={hovered}
        visibleEdgeColor="white"
        hiddenEdgeColor="white"
        edgeStrength={3}
        edgeThickness={1}
      />
      <sMAAPass attachArray="passes" args={[scene, camera]} />

      {/* <shaderPass
        attachArray="passes"
        args={[FXAAShader]}
        material-uniforms-resolution-value={[
          1 / (size.width * window.devicePixelRatio),
          1 / (size.height * window.devicePixelRatio),
        ]}
        renderToScreen
      /> */}

      {/* Cel Shading Pass */}
      {/* <shaderPass
        attachArray="passes"
        args={[CelShadingPass]}
        uniforms-tDiffuse-value={target.texture}
      /> */}
    </Effects>
  );
};
